// Monkey patch ResizeObserver to prevent the loop error at the source
if (typeof window !== 'undefined' && window.ResizeObserver) {
  const OriginalResizeObserver = window.ResizeObserver;

  // @ts-ignore
  window.ResizeObserver = class PatchedResizeObserver extends OriginalResizeObserver {
    constructor(callback: ResizeObserverCallback) {
      super((entries, observer) => {
        // Defer the callback to the next animation frame to avoid the loop error
        window.requestAnimationFrame(() => {
          // Check if entries are valid before calling back
          if (!Array.isArray(entries) || !entries.length) return;
          callback(entries, observer);
        });
      });
    }
  };
}

export {};
